module.exports = "/shared/img/hr-disabled-btn.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/hr-disabled-btn.png
// module id = 10
// module chunks = 13